import {
  TAnimalDetailsGenderField,
  TApplicationSADocPacketGet,
  TApplicationSADocPacketGetUI,
  TEditingWeightField,
  TEditingWeightFieldUi,
} from 'data/types/Applications.types';
import {
  TAuthConverter,
  TConvertor,
  TCreateConverter,
  TDeleteConverter,
  TFetchConverter,
} from 'data/types/Converter.types';
import {
  EGender,
  EReproductive,
  EValueEditingStates,
  EVetRecordTypeEnum,
  TExpirationDateType,
} from 'data/types/GeneralTypes';
import { vaccinationData } from 'data/datas/GenericData';
import {
  EAnimalResidencyTagUI,
  EAnimalResidencyTagDB,
  EAnimalApplicationStatusUI,
  EAnimalApplicationStatusDB,
  EAnimalActionDB,
  EAnimalActionUI,
  EAnimalStatusDB,
  EAnimalStatusUI,
  EAnimalTypes,
  EAnimalTypesUI,
  EAuthorizationStatus,
  EAuthorizationStatusUi,
  EConvertAnimalStatus,
  EConvertAnimalStatusUI,
  ENotBeingChargedReasonDB,
  ENotBeingChargedReasonUI,
  EResidenciesStatus,
  EResidenciesStatusUI,
  EResidencyStateDB,
  EResidencyStateUI,
  EVetRecordDateType,
  EVetRecordTypeEnumDB,
  TAnimalApplication,
  TAnimalApplicationRelatedPropertyManagers,
  TAnimalApplicationRelatedPropertyManagersUi,
  TAnimalApplicationUi,
  TAnimalBasicInfo,
  TAnimalBasicInfoUi,
  TAnimalDB,
  TAnimalDetail,
  TAnimalDetailsGenderFieldUi,
  TAnimalDetailUi,
  TAnimalInfoDB,
  TAnimalInfoUI,
  TAnimalResidencyDB,
  TAnimalResidencyUI,
  TAnimalStatusDetailsDB,
  TAnimalStatusDetailsUI,
  TAnimalUI,
  TAnimalDetailVetRecordCreate,
  TAnimalDetailVetRecordCreateUi,
  TAnimalWarningVerificationDB,
  TAnimalWarningVerificationUI,
  TApproveAnimalTypeConvDB,
  TApproveAnimalTypeConvUI,
  TBlockedAction,
  TBlockedActionUI,
  TChangedRecords,
  TChargingStatusUpdateDB,
  TChargingStatusUpdateUI,
  TConversionType,
  TConversionTypeUI,
  TResidentTypeChange,
  TResidentTypeChangeUI,
  TMarkAsDiscoverdDB,
  TMarkAsDiscoverdUI,
  TMarkAsPNCDB,
  TMarkAsPNCUI,
  TMarkKnownDB,
  TMarkKnownUI,
  TNotesDB,
  TNotesUI,
  TRejectAnimalTypeConvDB,
  TRejectAnimalTypeConvUI,
  TRemoveDiscoveredDB,
  TRemoveDiscoveredUI,
  TResidencies,
  TResidenciesUi,
  TTenantDetail,
  TTenantDetailUi,
  TTenantInfoDB,
  TTenantInfoUI,
  TUpdateAnimalTypeDB,
  TUpdateAnimalTypeUI,
  TVetRecord,
  TVetRecordDocuments,
  TVetRecordDocumentsUI,
  TVetRecordExpirationUpdate,
  TVetRecordExpirationUpdateUI,
  TVetRecordTypeNameUpdate,
  TVetRecordTypeNameUpdateUI,
  TVetRecordUI,
  TUpdateAnimalNameUI,
  TUpdateAnimalNameDB,
  TUpdateAnimalSpeciesUI,
  TUpdateAnimalSpeciesDB,
  TUpdateAnimalBreedUI,
  TUpdateAnimalBreedDB,
  TAnimalBreedUI,
  TAnimalBreedDB,
  TUpdateAnimalMicrochipDateUI,
  TUpdateAnimalMicrochipDateDB,
  TUpdateAnimalWeightUI,
  TUpdateAnimalWeightDB,
  TUpdateAnimalColorsUI,
  TUpdateAnimalColorsDB,
  TUpdateAnimalTrainedForUI,
  TUpdateAnimalTrainedForDB,
  TUpdateAnimalGenderUI,
  TUpdateAnimalGenderDB,
  TUpdateAnimalHouseTrainedUI,
  TUpdateAnimalHouseTrainedDB,
  TUpdateAnimalBirthDateUI,
  TUpdateAnimalBirthDateDB,
  TUpdateAnimalReproductiveUI,
  TUpdateAnimalReproductiveDB,
  TUpdateAnimalProfilePictureUI,
  TUpdateAnimalProfilePictureDB,
  TAggressiveBehaviorUI,
  TAggressiveBehaviorDB,
  TAnimalInfoPropUI,
  TAnimalInfoPropDB,
  TAnimalColorsUI,
  TAnimalColorsDB,
  TUpdateAnimalAggressiveBehaviorUI,
  TUpdateAnimalAggressiveBehaviorDB,
  TApproveApplicationUI,
  TApproveApplicationDB,
  TApproveApplicationFormProps,
  TApproveApplicationFormPropsUI,
  TAnimalRequirementsSetNoteDB,
  TAnimalRequirementsSetNoteUI,
  TAnimalRequirementsSetDB,
  TAnimalRequirementsSetUI,
  EAnimalPaymentStatusUI,
  EAnimalPaymentStatusDB,
  TAnimalPetRentDateUI,
  TAnimalPetRentDateDB,
  EVetRecordTypeEnumUI,
  TDeleteAnimalUI,
  TDeleteAnimalDB,
  EMoveOutOrRetractReasonTypeUI,
  EMoveOutOrRetractReasonTypeDB,
} from 'data/types/Animal.types';
import { trainerInfoConvertor } from 'data/convertors/AnimalTraining.convertors';
import { EDocPacketStatusUi } from 'data/types/DocPacket.types';
import {
  EVetRecordStatus,
  EVetRecordStatusUi,
  TAnimalVetRecordTypeDB,
  TAnimalVetRecordTypeUI,
  TAnimalVetRecordVacTypeDB,
  TAnimalVetRecordVacTypeUI,
  TApplicationVetRecords,
  TApplicationVetRecordsUI,
} from 'data/types/VetRecord.types';
import { b64toBlob } from 'api/sevices/fileServices';
import {
  animalChargingStatusConverter,
  applicationStatusConvertor,
  failsConvertor,
  fileDataTypeConverter,
  formattedDate,
  genderEnumConvertor,
  getFirstLetters,
  propertyInfoConverter,
  propertyManagementInfoConverter,
  statusChangeInfoConverter,
  statusInfoWithResourceConverter,
  verificationStatusConverter,
} from './General.converters';
import {
  docPacketStatusConverter,
  getHPDocPacketsConvertor,
} from './DocPacket.convertors';

import { tagConverter, tenantTagConverter } from './Tags.converters';
import { toTitleCase } from 'helpers/utils';
import {
  ERequiredDocument,
  ESpeciesRequirementDB,
  TCustomRequiredDocumentUI,
  TPropertyConfigSetGetDB,
  TPropertyConfigSetGetUI,
  TPropertyConfigSetPetRestrictionsDB,
  TPropertyConfigSetPetRestrictionsUI,
  TRequiredDocumentsDB,
  TRequiredDocumentsUI,
  TSpeciesRequirementUI,
} from 'data/types/propertyConfigSet.types';

export const vetRecordStatusConverter: TConvertor<
  EVetRecordStatusUi,
  EVetRecordStatus
> = {
  fromDb: data => {
    const statuses: {
      [key in EVetRecordStatus]: EVetRecordStatusUi;
    } = {
      [EVetRecordStatus.NOT_VERIFIED]: EVetRecordStatusUi.NOT_VERIFIED,
      [EVetRecordStatus.VERIFIED]: EVetRecordStatusUi.VERIFIED,
      [EVetRecordStatus.IN_PROGRESS]: EVetRecordStatusUi.IN_PROGRESS,
    };
    return statuses[data];
  },
  toDb: data => {
    const statuses: {
      [key in EVetRecordStatusUi]: EVetRecordStatus;
    } = {
      [EVetRecordStatusUi.NOT_VERIFIED]: EVetRecordStatus.NOT_VERIFIED,
      [EVetRecordStatusUi.VERIFIED]: EVetRecordStatus.VERIFIED,
      [EVetRecordStatusUi.IN_PROGRESS]: EVetRecordStatus.IN_PROGRESS,
    };
    return statuses[data];
  },
};

export const reproductiveConvertor: TFetchConverter<EReproductive, EGender> = {
  fromDb: data => {
    const reproduction: {
      [key in EGender]: EReproductive;
    } = {
      [EGender.FEMALE]: EReproductive.SPAYED,
      [EGender.MALE]: EReproductive.NEUTERED,
    };
    return reproduction[data];
  },
};

export const animalTypesConvertor: TConvertor<EAnimalTypesUI, EAnimalTypes> = {
  fromDb: data => {
    return EAnimalTypesUI[EAnimalTypes[data] as keyof typeof EAnimalTypesUI];
  },
  toDb: data => {
    return EAnimalTypes[EAnimalTypesUI[data] as keyof typeof EAnimalTypes];
  },
};

export const animalPaymentStatusConverter: TConvertor<
  EAnimalPaymentStatusUI,
  EAnimalPaymentStatusDB
> = {
  fromDb: data => {
    const dataMapper: {
      [key in EAnimalPaymentStatusDB]: EAnimalPaymentStatusUI;
    } = {
      [EAnimalPaymentStatusDB.PAID]: EAnimalPaymentStatusUI.PAID,
      [EAnimalPaymentStatusDB.MISSING]: EAnimalPaymentStatusUI.MISSING,
      [EAnimalPaymentStatusDB.MISSING_RENEWAL]:
        EAnimalPaymentStatusUI.MISSING_RENEWAL,
      [EAnimalPaymentStatusDB.SCHEDULED_RENEWAL]:
        EAnimalPaymentStatusUI.SCHEDULED_RENEWAL,
    };
    return dataMapper[data];
  },
  toDb: data => {
    const dataMapper: {
      [key in EAnimalPaymentStatusUI]: EAnimalPaymentStatusDB;
    } = {
      [EAnimalPaymentStatusUI.PAID]: EAnimalPaymentStatusDB.PAID,
      [EAnimalPaymentStatusUI.MISSING]: EAnimalPaymentStatusDB.MISSING,
      [EAnimalPaymentStatusUI.MISSING_RENEWAL]:
        EAnimalPaymentStatusDB.MISSING_RENEWAL,
      [EAnimalPaymentStatusUI.SCHEDULED_RENEWAL]:
        EAnimalPaymentStatusDB.SCHEDULED_RENEWAL,
    };
    return dataMapper[data];
  },
};

export const animalBasicInfoConvertor: TFetchConverter<
  TAnimalBasicInfoUi,
  TAnimalBasicInfo
> = {
  fromDb: data => {
    return {
      birthDate: data.birthDate
        ? formattedDate(data.birthDate, 'MM/DD/YYYY')
        : null,
      breed: data.breed ? animalInfoPropConverter.fromDb(data.breed) : null,
      gender: genderEnumConvertor.fromDb(data.gender),
      id: data.id,
      isDeleted: data.isDeleted,
      isHouseTrained: data.isHouseTrained,
      reproduction: data.isReproductive
        ? reproductiveConvertor.fromDb(data.gender)
        : null,
      isReproductive: data.isReproductive,
      name: data.name,
      photoGallery: data.photoGallery,
      primaryColor: data.primaryColor
        ? animalInfoPropConverter.fromDb(data.primaryColor)
        : null,
      profilePicture: data.profilePicture,
      secondaryColor1: data.secondaryColor1
        ? animalInfoPropConverter.fromDb(data.secondaryColor1)
        : null,
      secondaryColor2: data.secondaryColor2
        ? animalInfoPropConverter.fromDb(data.secondaryColor2)
        : null,
      species: data.species
        ? animalInfoPropConverter.fromDb(data.species)
        : null,
      status: verificationStatusConverter.fromDb(data.status),
      type: animalTypesConvertor.fromDb(data.type),
      weight: data.weight,
      microchip: data.microchip,
      trainedFor: data.trainedFor,
      isRequiredBecauseOfDisability: data.isRequiredBecauseOfDisability,
      aggressiveBehavior: data.aggressiveBehavior
        ? aggressiveBehaviorConverter.fromDb(data.aggressiveBehavior)
        : null,
    };
  },
};

export const tenantDetailConvertor: TFetchConverter<
  TTenantDetailUi,
  TTenantDetail
> = {
  fromDb: data => {
    return {
      id: data.id,
      photo: data.photo,
      name: data.name,
      email: data.email,
      phone: data.phone,
      deactivationStatusChangeInfo: data.deactivationStatusChangeInfo
        ? statusChangeInfoConverter.fromDb(data.deactivationStatusChangeInfo)
        : null,
    };
  },
};

export const residenciesStatusConverter: TConvertor<
  EResidenciesStatusUI,
  EResidenciesStatus
> = {
  fromDb: data => {
    const dataMapper: { [key in EResidenciesStatus]: EResidenciesStatusUI } = {
      [EResidenciesStatus.APPLICANT]: EResidenciesStatusUI.APPLICANT,
      [EResidenciesStatus.RESIDENT]: EResidenciesStatusUI.RESIDENT,
      [EResidenciesStatus.FUTURE]: EResidenciesStatusUI.FUTURE,
      [EResidenciesStatus.MOVED_OUT]: EResidenciesStatusUI.MOVED_OUT,
      [EResidenciesStatus.REJECTED]: EResidenciesStatusUI.REJECTED,
      [EResidenciesStatus.NOTICE]: EResidenciesStatusUI.NOTICE,
    };
    return dataMapper[data];
  },
  toDb: data => {
    const dataMapper: { [key in EResidenciesStatusUI]: EResidenciesStatus } = {
      [EResidenciesStatusUI.APPLICANT]: EResidenciesStatus.APPLICANT,
      [EResidenciesStatusUI.RESIDENT]: EResidenciesStatus.RESIDENT,
      [EResidenciesStatusUI.FUTURE]: EResidenciesStatus.FUTURE,
      [EResidenciesStatusUI.MOVED_OUT]: EResidenciesStatus.MOVED_OUT,
      [EResidenciesStatusUI.REJECTED]: EResidenciesStatus.REJECTED,
      [EResidenciesStatusUI.NOTICE]: EResidenciesStatus.NOTICE,
    };
    return dataMapper[data];
  },
};

export const authorizationStatusConverter: TConvertor<
  EAuthorizationStatusUi,
  EAuthorizationStatus
> = {
  fromDb: data => {
    const statuses: {
      [key in EAuthorizationStatus]: EAuthorizationStatusUi;
    } = {
      [EAuthorizationStatus.AUTHORIZED]: EAuthorizationStatusUi.AUTHORIZED,
    };
    return statuses[data];
  },
  toDb: data => {
    const statuses: {
      [key in EAuthorizationStatusUi]: EAuthorizationStatus;
    } = {
      [EAuthorizationStatusUi.AUTHORIZED]: EAuthorizationStatus.AUTHORIZED,
    };
    return statuses[data];
  },
};
export const notesConvertor: TFetchConverter<TNotesUI, TNotesDB> = {
  fromDb: data => {
    return {
      creationTime: data.creationTime,
      creatorName: data.creatorName,
      id: data.id,
      text: data.text,
    };
  },
};
export const animalApplicationRelatedPropertyManagersConvertor: TFetchConverter<
  TAnimalApplicationRelatedPropertyManagersUi,
  TAnimalApplicationRelatedPropertyManagers
> = {
  fromDb: data => {
    return {
      id: data.id,
      emailAddress: data.emailAddress,
      isLandlord: data.isLandlord,
      name: data.name,
      phoneNumber: data.phoneNumber,
    };
  },
};

export const animalApplicationConvertor: TFetchConverter<
  TAnimalApplicationUi,
  TAnimalApplication
> = {
  fromDb: data => {
    return {
      id: data.id,
      propertyName: data.propertyName,
      unitNumber: data.unitNumber,
      propertyManagementBusinessName: data.propertyManagementBusinessName,
      propertyManagementBusinessLogo: data.propertyManagementBusinessLogo,
      propertyManagerName: data.propertyManagerName,
      leaseStartDate: data.leaseStartDate
        ? formattedDate(data.leaseStartDate)
        : '-',
      leaseToDate: data.leaseToDate ? formattedDate(data.leaseToDate) : null,
      applicationStatus: applicationStatusConvertor.fromDb(
        data.applicationStatus,
      ),
      policyId: data.policyId,
      relatedPropertyManagers: data.relatedPropertyManagers.map(item =>
        animalApplicationRelatedPropertyManagersConvertor.fromDb(item),
      ),
      landlord: data.landlord,
      signedDocType: data.signedDocType,
    };
  },
};

export const applicationSADocPacketConvertor: TFetchConverter<
  TApplicationSADocPacketGetUI,
  TApplicationSADocPacketGet
> = {
  fromDb: data => {
    return {
      id: data.id,
      trainerInfo: trainerInfoConvertor.fromDb(data.trainerInfo),
      saLetters: (data.saLetters || []).map(letter =>
        fileDataTypeConverter.fromDb(letter),
      ),
      trainedFor: data.trainedFor,
      startTime: data.trainingStartDate,
      endTime: data.trainingEndDate,
      canEdit: false,
      canModifyDocs:
        docPacketStatusConverter.fromDb(data.status) ===
        EDocPacketStatusUi.NONE,
      fails: failsConvertor.fromDb(data.fails || {}),
      status: docPacketStatusConverter.fromDb(data.status),
    };
  },
};

export const animalVetRecordExpirationDateConvertor: TCreateConverter<
  TExpirationDateType,
  TExpirationDateType
> = {
  toDb: data => ({
    expirable: data.expirable,
    date: `${data.date}Z`,
  }),
};

export const vetRecordTypeConverter: TFetchConverter<
  TAnimalVetRecordVacTypeUI,
  TAnimalVetRecordVacTypeDB
> = {
  fromDb(data) {
    return {
      predefined: data.predefined,
      value:
        EVetRecordTypeEnumUI[data.value as keyof typeof EVetRecordTypeEnumUI] ||
        data.value,
    };
  },
};

export const animalVetRecordExpirationConvertor: TFetchConverter<
  TExpirationDateType,
  TExpirationDateType
> = {
  fromDb: data => {
    return {
      date: data.date,
      expirable: data.expirable,
      expired: data.expired,
    };
  },
};

export const vetRecordsDataConverter: TFetchConverter<
  TAnimalVetRecordTypeUI,
  TAnimalVetRecordTypeDB
> = {
  fromDb(data) {
    return {
      id: data.id,
      type: vetRecordTypeConverter.fromDb(data.type),
      expiration:
        data.expiration &&
        animalVetRecordExpirationConvertor.fromDb(data.expiration),
      isExpired: data.isExpired,
      requiredByVerificationConfiguration:
        data.requiredByVerificationConfiguration,
      showTextWhetherDocumentIsRequiredOrNot:
        data.showTextWhetherDocumentIsRequiredOrNot ?? true,
      verificationStatus:
        data.verificationStatus &&
        vetRecordStatusConverter.fromDb(data.verificationStatus),
      isLocked: data.isLocked,
    };
  },
};

export const animalVetRecordConvertor: TFetchConverter<
  TApplicationVetRecordsUI,
  TApplicationVetRecords
> = {
  fromDb: data => {
    return {
      records: (data.records || []).map(record =>
        vetRecordsDataConverter.fromDb(record),
      ),
      id: data.id,
      documentFiles: data.documentFiles,
      canEdit: !data.records.some(record => record.isLocked),
    };
  },
};

export const getAnimalWarningVerificationConverter: TFetchConverter<
  TAnimalWarningVerificationUI,
  TAnimalWarningVerificationDB
> = {
  fromDb: data => ({
    hasNotVerifiedDocument: data.hasNotVerifiedDocument,
  }),
};

export const animalActionConverter: TConvertor<
  EAnimalActionUI,
  EAnimalActionDB
> = {
  fromDb: data => {
    const action: { [key in EAnimalActionDB]: EAnimalActionUI } = {
      [EAnimalActionDB.CONVERT]: EAnimalActionUI.CONVERT,
    };
    return action[data];
  },
  toDb: data => {
    const action: { [key in EAnimalActionUI]: EAnimalActionDB } = {
      [EAnimalActionUI.CONVERT]: EAnimalActionDB.CONVERT,
    };
    return action[data];
  },
};

export const animalBlockedActionConverter: TFetchConverter<
  TBlockedActionUI,
  TBlockedAction
> = {
  fromDb: data => ({
    animalAction: animalActionConverter.fromDb(data.animalAction),
    reason: data.reason,
  }),
};

export const animalConversionStatusConvertor: TFetchConverter<
  EConvertAnimalStatusUI,
  EConvertAnimalStatus
> = {
  fromDb: data => {
    const statuses: {
      [key in EConvertAnimalStatus]: EConvertAnimalStatusUI;
    } = {
      [EConvertAnimalStatus.APPROVED]: EConvertAnimalStatusUI.APPROVED,
      [EConvertAnimalStatus.PENDING]: EConvertAnimalStatusUI.PENDING,
      [EConvertAnimalStatus.REJECTED]: EConvertAnimalStatusUI.REJECTED,
    };
    return statuses[data];
  },
};

export const residentTypeChangeConvertor: TFetchConverter<
  TResidentTypeChangeUI,
  TResidentTypeChange
> = {
  fromDb: data => ({
    changedAt: formattedDate(data.changedAt),
    changedAtRaw: data.changedAt,
    fromType: animalTypesConvertor.fromDb(data.fromType),
    toType: animalTypesConvertor.fromDb(data.toType),
    changedByName: data.changedByName || undefined,
  }),
};

export const animalConversionsConvertor: TFetchConverter<
  TConversionTypeUI,
  TConversionType
> = {
  fromDb: data => {
    return {
      trainedFor: data.trainedFor,
      observableDisability: data.observableDisability,
      trainerDocumentInfoNotProvidedReason:
        data.trainerDocumentInfoNotProvidedReason,
      withdrawnRequest: !!data.withdrawnRequest,
      hpDocumentInfoNotProvidedReason: data.hpDocumentInfoNotProvidedReason,
      conversionApprover: data.approveActorName || undefined,
      createdAt: formattedDate(data.createdAt),
      createdAtRaw: data.createdAt,
      fromType: animalTypesConvertor.fromDb(data.fromType),
      hpDocumentPacket: data.hpDocumentPacket
        ? getHPDocPacketsConvertor.fromDb(data.hpDocumentPacket)
        : null,
      id: data.id,
      reason: data.reason,
      saDocumentPacket: data.saDocumentPacket
        ? applicationSADocPacketConvertor.fromDb(data.saDocumentPacket)
        : null,
      status: animalConversionStatusConvertor.fromDb(data.status),
      toType: animalTypesConvertor.fromDb(data.toType),
    };
  },
};

export const editingWeightFieldConvertor: TFetchConverter<
  TEditingWeightFieldUi,
  TEditingWeightField
> = {
  fromDb: data => {
    return {
      value: data?.value ? data.value.toString() : '',
      unit: data?.unit || 'LBS',
      canEdit: data.allowedOperations.some(item =>
        [EValueEditingStates.SET, EValueEditingStates.UPDATE].includes(item),
      ),
      canRemove: data.allowedOperations.some(item =>
        [EValueEditingStates.SET, EValueEditingStates.REMOVE].includes(item),
      ),
    };
  },
};

export const animalDetailsGenderConverter: TFetchConverter<
  TAnimalDetailsGenderFieldUi,
  TAnimalDetailsGenderField
> = {
  fromDb: data => {
    return {
      value: genderEnumConvertor.fromDb(data.value),
      canEdit: data.allowedOperations.some(item =>
        [EValueEditingStates.SET, EValueEditingStates.UPDATE].includes(item),
      ),
      canRemove: data.allowedOperations.some(item =>
        [EValueEditingStates.SET, EValueEditingStates.REMOVE].includes(item),
      ),
    };
  },
};

export const updateVetRecordDocumentsConvertor: TCreateConverter<
  TVetRecordDocumentsUI,
  TVetRecordDocuments
> = {
  toDb: data => ({
    animalId: data.animalId,
    vetRecordId: data.vetRecordId,
    newFiles: (data.newFiles || []).map(doc => ({
      name: doc.name,
      url: doc.url,
    })),
    removedDocumentsId: data.removedDocumentsId || [],
    removedRecordIds: data.removedRecordIds || [],
    newRecords: (data.newRecords || []).map(record => ({
      type: vaccinationData.includes(record.type.value as string)
        ? {
            predefined:
              EVetRecordTypeEnumDB[
                record.type.value as keyof typeof EVetRecordTypeEnumDB
              ],
          }
        : { custom: record.type.value },
      expiration: record.expiration,
    })),
    changedRecords: (data.changedRecords || []).map(record => ({
      type: vaccinationData.includes(record.type.value as string)
        ? {
            predefined:
              EVetRecordTypeEnumDB[
                record.type.value as keyof typeof EVetRecordTypeEnumDB
              ],
          }
        : { custom: record.type.value },
      expiration: record.expiration,
      id: record.id,
    })),
  }),
};

export const deleteVetRecordConvertor: TDeleteConverter<
  TVetRecordUI,
  TVetRecord
> = {
  toDb: data => ({
    animalId: data.animalId,
    vetRecordId: data.vetRecordId,
  }),
};

export const vetRecordExpirationConverter: TCreateConverter<
  TVetRecordExpirationUpdateUI,
  TExpirationDateType
> = {
  toDb(data) {
    return {
      expirable: data.vetRecordDateType !== EVetRecordDateType.UNEXPIRED,
      date:
        data.vetRecordDateType !== EVetRecordDateType.UNEXPIRED
          ? data.expirationDate
          : '',
    };
  },
};
export const updatedVetRecordsConverter: TCreateConverter<
  TVetRecordExpirationUpdateUI,
  TChangedRecords
> = {
  toDb(data) {
    return {
      expiration: vetRecordExpirationConverter.toDb(data),
      id: data.vetRecordId,
    };
  },
};

export const vetRecordExpirationUpdateConverter: TCreateConverter<
  TVetRecordExpirationUpdateUI,
  TVetRecordExpirationUpdate
> = {
  toDb: data => {
    return {
      animalId: data.animalId,
      vetRecordId: data.recordId,
      changedRecords: [updatedVetRecordsConverter.toDb(data)],
    };
  },
};

export const updateAnimalTypeConverter: TCreateConverter<
  TUpdateAnimalTypeUI,
  TUpdateAnimalTypeDB
> = {
  toDb: data => {
    return {
      animalId: data.animalId,
      toType: animalTypesConvertor.toDb(data.toType),
      ...(data.predefinedConversionReasonId && {
        predefinedConversionReasonId: data.predefinedConversionReasonId,
      }),
      ...(data.reason && { reason: data.reason }),
    };
  },
};

export const approveAnimalTypeConversionConverter: TCreateConverter<
  TApproveAnimalTypeConvUI,
  TApproveAnimalTypeConvDB
> = {
  toDb: data => {
    return {
      animalId: data.animalId,
      animalConversionId: data.animalConversionId,
    };
  },
};

export const rejectAnimalTypeConversionConverter: TCreateConverter<
  TRejectAnimalTypeConvUI,
  TRejectAnimalTypeConvDB
> = {
  toDb: data => {
    return {
      animalId: data.animalId,
      animalConversionId: data.animalConversionId,
      predefinedConversionReasonId: data.predefinedConversionReasonId,
      reason: data.reason,
    };
  },
};

export const vetRecordTypeUpdateConverter: TCreateConverter<
  TVetRecordTypeNameUpdateUI,
  TVetRecordTypeNameUpdate
> = {
  toDb: data => {
    return {
      animalId: data.animalId,
      vetRecordId: data.vetRecordId,
      type:
        data.type === 'Rabbies'
          ? {
              predefined:
                EVetRecordTypeEnum[
                  data.type as keyof typeof EVetRecordTypeEnum
                ],
            }
          : { custom: data.type },
    };
  },
};

export const animalResidencyStateConverter: TConvertor<
  EResidencyStateUI,
  EResidencyStateDB
> = {
  fromDb: data => {
    const statuses: {
      [key in EResidencyStateDB]: EResidencyStateUI;
    } = {
      [EResidencyStateDB.NONE]: EResidencyStateUI.NONE,
      [EResidencyStateDB.APPROVED]: EResidencyStateUI.APPROVED,
      [EResidencyStateDB.PENDING]: EResidencyStateUI.PENDING,
      [EResidencyStateDB.FUTURE]: EResidencyStateUI.FUTURE,
      [EResidencyStateDB.ABANDONED]: EResidencyStateUI.ABANDONED,
    };
    return statuses[data];
  },
  toDb: data => {
    const statuses: {
      [key in EResidencyStateUI]: EResidencyStateDB;
    } = {
      [EResidencyStateUI.NONE]: EResidencyStateDB.NONE,
      [EResidencyStateUI.APPROVED]: EResidencyStateDB.APPROVED,
      [EResidencyStateUI.PENDING]: EResidencyStateDB.PENDING,
      [EResidencyStateUI.FUTURE]: EResidencyStateDB.FUTURE,
      [EResidencyStateUI.ABANDONED]: EResidencyStateDB.ABANDONED,
    };
    return statuses[data];
  },
};

export const animalStatusConverter: TConvertor<
  EAnimalStatusUI,
  EAnimalStatusDB
> = {
  fromDb: data => {
    const statuses: {
      [key in EAnimalStatusDB]: EAnimalStatusUI;
    } = {
      [EAnimalStatusDB.ARCHIVED]: EAnimalStatusUI.ARCHIVED,
      [EAnimalStatusDB.APPROVED]: EAnimalStatusUI.APPROVED,
      [EAnimalStatusDB.PENDING]: EAnimalStatusUI.PENDING,
      [EAnimalStatusDB.MOVED_IN]: EAnimalStatusUI.MOVED_IN,
      [EAnimalStatusDB.MOVED_OUT]: EAnimalStatusUI.MOVED_OUT,
      [EAnimalStatusDB.NOT_APPROVED]: EAnimalStatusUI.NOT_APPROVED,
      [EAnimalStatusDB.RETRACTED]: EAnimalStatusUI.RETRACTED,
      [EAnimalStatusDB.CONDITIONALLY_MOVED_IN]:
        EAnimalStatusUI.CONDITIONALLY_MOVED_IN,
      [EAnimalStatusDB.CONDITIONALLY_APPROVED]:
        EAnimalStatusUI.CONDITIONALLY_APPROVED,
      [EAnimalStatusDB.ABANDONED]: EAnimalStatusUI.ABANDONED,
    };
    return statuses[data];
  },
  toDb: data => {
    const statuses: {
      [key in EAnimalStatusUI]: EAnimalStatusDB;
    } = {
      [EAnimalStatusUI.ARCHIVED]: EAnimalStatusDB.ARCHIVED,
      [EAnimalStatusUI.APPROVED]: EAnimalStatusDB.APPROVED,
      [EAnimalStatusUI.PENDING]: EAnimalStatusDB.PENDING,
      [EAnimalStatusUI.MOVED_IN]: EAnimalStatusDB.MOVED_IN,
      [EAnimalStatusUI.MOVED_OUT]: EAnimalStatusDB.MOVED_OUT,
      [EAnimalStatusUI.NOT_APPROVED]: EAnimalStatusDB.NOT_APPROVED,
      [EAnimalStatusUI.RETRACTED]: EAnimalStatusDB.RETRACTED,
      [EAnimalStatusUI.CONDITIONALLY_APPROVED]:
        EAnimalStatusDB.CONDITIONALLY_APPROVED,
      [EAnimalStatusUI.CONDITIONALLY_MOVED_IN]:
        EAnimalStatusDB.CONDITIONALLY_MOVED_IN,
      [EAnimalStatusUI.ABANDONED]: EAnimalStatusDB.ABANDONED,
    };
    return statuses[data];
  },
};
export const animalApplicationStatusConverter: TFetchConverter<
  EAnimalApplicationStatusUI | null,
  EAnimalApplicationStatusDB | null
> = {
  fromDb: data => {
    if (!data) {
      return null;
    }
    const dataMapper: {
      [key in EAnimalApplicationStatusDB]: EAnimalApplicationStatusUI;
    } = {
      [EAnimalApplicationStatusDB.PENDING]: EAnimalApplicationStatusUI.PENDING,
      [EAnimalApplicationStatusDB.APPROVED]:
        EAnimalApplicationStatusUI.APPROVED,
      [EAnimalApplicationStatusDB.NOT_APPROVED]:
        EAnimalApplicationStatusUI.NOT_APPROVED,
      [EAnimalApplicationStatusDB.ARCHIVED]:
        EAnimalApplicationStatusUI.ARCHIVED,
      [EAnimalApplicationStatusDB.RETRACTED]:
        EAnimalApplicationStatusUI.RETRACTED,
      [EAnimalApplicationStatusDB.CONDITIONALLY_APPROVED]:
        EAnimalApplicationStatusUI.CONDITIONALLY_APPROVED,
      [EAnimalApplicationStatusDB.ABANDONED]:
        EAnimalApplicationStatusUI.ABANDONED,
      [EAnimalApplicationStatusDB.APPROVED_UNTIL_RENEWAL]:
        EAnimalApplicationStatusUI.APPROVED_UNTIL_RENEWAL,
    };
    return dataMapper[data];
  },
};

// NONE and null both mean "no tag" to the UI; the chip renders nothing for null.
export const animalResidencyTagConverter: TFetchConverter<
  EAnimalResidencyTagUI | null,
  EAnimalResidencyTagDB | null | undefined
> = {
  fromDb: data => {
    if (!data || data === EAnimalResidencyTagDB.NONE) {
      return null;
    }
    return data === EAnimalResidencyTagDB.MOVED_IN
      ? EAnimalResidencyTagUI.MOVED_IN
      : EAnimalResidencyTagUI.MOVED_OUT;
  },
};

// The details endpoint composes this live, so an animal always has one — but a response from
// an older backend does not, and the chips then render nothing rather than breaking.
export const animalStatusDetailsConverter: TFetchConverter<
  TAnimalStatusDetailsUI,
  TAnimalStatusDetailsDB | null | undefined
> = {
  fromDb: data => ({
    applicationStatus: animalApplicationStatusConverter.fromDb(
      data?.applicationStatus ?? null,
    ),
    residencyTag: animalResidencyTagConverter.fromDb(data?.residencyTag),
    applicationId: data?.applicationId ?? null,
    conditional: data?.conditional ?? false,
    approvedUntilRenewalDate: data?.approvedUntilRenewalDate
      ? formattedDate(data.approvedUntilRenewalDate)
      : null,
  }),
};

export const animalInfoConverter: TFetchConverter<
  TAnimalInfoUI,
  TAnimalInfoDB
> = {
  fromDb: data => {
    return {
      animalId: data.animalId,
      animalName: data.animalName,
      animalSpecie: data.animalSpecie,
      animalSpeciePredefinedId: data.animalSpecieId,
      animalProfilePicture: data.animalProfilePicture,
      animalType: animalTypesConvertor.fromDb(data.animalType),
      animalResidencyState: animalResidencyStateConverter.fromDb(
        data.animalResidencyState,
      ),
      applicationStatus: animalApplicationStatusConverter.fromDb(
        data.statusDetails?.applicationStatus ?? null,
      ),
      approvedUntilRenewalDate: data.statusDetails?.approvedUntilRenewalDate
        ? formattedDate(data.statusDetails.approvedUntilRenewalDate)
        : null,
      residencyTag: animalResidencyTagConverter.fromDb(
        data.statusDetails?.residencyTag,
      ),
      animalStatus: verificationStatusConverter.fromDb(data.animalStatus),
      firstLetters: getFirstLetters(data.animalName),
      paymentStatus: data.paymentStatus
        ? animalPaymentStatusConverter.fromDb(data.paymentStatus)
        : null,
    };
  },
};

export const tenantInfoConverter: TFetchConverter<
  TTenantInfoUI,
  TTenantInfoDB
> = {
  fromDb: data => {
    return {
      tenantId: data.tenantId,
      tenantName: data.tenantName,
    };
  },
};
export const animalConverter: TAuthConverter<
  { [key: string]: string | string[] } | undefined,
  { [key: string]: string | string[] },
  TAnimalUI,
  TAnimalDB
> = {
  fromDb: data => {
    const {
      animalId,
      animalStatus,
      animalName,
      animalSpecie,
      animalSpecieId,
      animalType,
      animalResidencyState,
      statusDetails,
      animalProfilePicture,
      tenantId,
      tenantName,
      propertyManagementName,
      propertyManagementId,
      propertyManagementLogo,
      propertyId,
      propertyName,
      creationTime,
      paymentStatus,
    } = data;
    return {
      animalInfo: animalInfoConverter.fromDb({
        animalId,
        animalStatus,
        animalName,
        animalSpecie,
        animalSpecieId,
        animalType,
        animalResidencyState,
        statusDetails,
        animalProfilePicture,
        paymentStatus,
      }),
      tenantInfo: tenantInfoConverter.fromDb({ tenantId, tenantName }),
      propertyManagement: propertyManagementInfoConverter.fromDb({
        propertyManagementName,
        propertyManagementId,
        propertyManagementLogo,
      }),
      read: data.read,
      propertyInfo: propertyInfoConverter.fromDb({ propertyId, propertyName }),
      creationTime: formattedDate(creationTime),
      unitNumber: data.unitName,
    };
  },
  toDb: filter => {
    const filtersObj: { [key: string]: string | string[] } = {};
    if (!filter) {
      return {};
    }
    Object.keys(filter).forEach(item => {
      if (
        (Array.isArray(filter[item]) && filter[item].length) ||
        (!Array.isArray(filter[item]) && !!filter[item])
      ) {
        filtersObj[item] = filter[item];
      }
    });
    return filtersObj;
  },
};

export const notBeingChargedReasonConverter: TConvertor<
  ENotBeingChargedReasonUI,
  ENotBeingChargedReasonDB
> = {
  fromDb: data => {
    const statuses: {
      [key in ENotBeingChargedReasonDB]: ENotBeingChargedReasonUI;
    } = {
      [ENotBeingChargedReasonDB.PET_FEE]: ENotBeingChargedReasonUI.PET_FEE,
      [ENotBeingChargedReasonDB.PET_RENT]: ENotBeingChargedReasonUI.PET_RENT,
    };
    return statuses[data];
  },
  toDb: data => {
    const statuses: {
      [key in ENotBeingChargedReasonUI]: ENotBeingChargedReasonDB;
    } = {
      [ENotBeingChargedReasonUI.PET_FEE]: ENotBeingChargedReasonDB.PET_FEE,
      [ENotBeingChargedReasonUI.PET_RENT]: ENotBeingChargedReasonDB.PET_RENT,
    };
    return statuses[data];
  },
};

export const updatePetChargingStatusConverter: TCreateConverter<
  TChargingStatusUpdateUI,
  TChargingStatusUpdateDB
> = {
  toDb: data => {
    return {
      tenantResidencyId: data.tenantResidencyId,
      animalResidencyId: data.animalResidencyId,
      chargingStatus: animalChargingStatusConverter.toDb(data.chargingStatus),
      ...(data.reason && { reason: data.reason }),
      ...(data.notBeingChargedReason && {
        notBeingChargedReason: notBeingChargedReasonConverter.toDb(
          data.notBeingChargedReason,
        ),
      }),
      ...(data.shouldTagAnimalAsPNC !== undefined && {
        shouldTagAnimalAsPNC: data.shouldTagAnimalAsPNC,
      }),
      ...(data.startDate && { startDate: data.startDate }),
      chargeType: data.chargeType,
    };
  },
};

export const markAsPNCConverter: TCreateConverter<TMarkAsPNCUI, TMarkAsPNCDB> =
  {
    toDb: data => {
      return {
        tenantResidencyId: data.tenantResidencyId,
        animalResidencyId: data.animalResidencyId,
        chargeType: data.chargeType,
      };
    },
  };

export const markKnownConverter: TCreateConverter<TMarkKnownUI, TMarkKnownDB> =
  {
    toDb: data => ({
      tenantResidencyId: data.tenantResidencyId,
      animalId: data.animalId,
    }),
  };

export const removeDiscoveredConverter: TCreateConverter<
  TRemoveDiscoveredUI,
  TRemoveDiscoveredDB
> = {
  toDb: data => {
    return {
      tenantResidencyId: data.tenantResidencyId,
      animalId: data.animalId,
    };
  },
};

export const markAsDiscoveredAnimalConverter: TCreateConverter<
  TMarkAsDiscoverdUI,
  TMarkAsDiscoverdDB
> = {
  toDb: data => {
    return {
      tenantResidencyId: data.tenantResidencyId,
      animalResidencyId: data.animalResidencyId,
      discoveredTagReason: data.discoveredTagReason,
      tag: tagConverter.toDb(data.tag) as TMarkAsDiscoverdDB['tag'],
    };
  },
};

export const petChargeDateConverter: TFetchConverter<
  TAnimalPetRentDateUI,
  TAnimalPetRentDateDB
> = {
  fromDb: data => {
    const formatPetRentMonthYear = (value?: string): string | undefined => {
      if (!value) {
        return undefined;
      }

      const match = value.trim().match(/^(\d{4})-(\d{2})$/);
      if (!match) {
        return undefined;
      }

      return `${match[2]}/${match[1]}`;
    };

    return {
      startedAtOnboarding: data.startedAtOnboarding,
      startDate: formatPetRentMonthYear(data.startDate),
      endDate: formatPetRentMonthYear(data.endDate),
    };
  },
};

export const animalResidencyConverter: TFetchConverter<
  TAnimalResidencyUI,
  TAnimalResidencyDB
> = {
  fromDb: data => {
    return {
      id: data.id,

      petRentChargingStatusDetails: data.petRentChargingStatusDetails
        ? {
            changeInfo: data.petRentChargingStatusDetails.changeInfo
              ? statusInfoWithResourceConverter.fromDb(
                  data.petRentChargingStatusDetails.changeInfo,
                )
              : null,
            changeReason: data.petRentChargingStatusDetails.changeReason,
            status: animalChargingStatusConverter.fromDb(
              data.petRentChargingStatusDetails.status,
            ),
          }
        : null,
      petFeeChargingStatusDetails: data.petFeeChargingStatusDetails
        ? {
            changeInfo: data.petFeeChargingStatusDetails.changeInfo
              ? statusInfoWithResourceConverter.fromDb(
                  data.petFeeChargingStatusDetails.changeInfo,
                )
              : null,
            changeReason: data.petFeeChargingStatusDetails.changeReason,
            status: animalChargingStatusConverter.fromDb(
              data.petFeeChargingStatusDetails.status,
            ),
          }
        : null,

      tags: (data.tags || []).map(item => tagConverter.fromDb(item)),
      canTagKnown: data.canTagKnown,
      cannotTagKnownReason: data.cannotTagKnownReason,
      status: animalStatusConverter.fromDb(data.status),
      discoveredTagReason: data.discoveredTagReason,
      policySignedBy: data.policySignedBy,
      policyDateSigned: data.policyDateSigned
        ? formattedDate(data.policyDateSigned)
        : 'N/A',
      policyName: data.policyName,
      policyContent: data.policyContent
        ? URL.createObjectURL(b64toBlob(data.policyContent, 'text/html'))
        : null,
      policyId: data.policyId,
      statusChangeInfo: data.statusChangeInfo
        ? statusChangeInfoConverter.fromDb(data.statusChangeInfo)
        : null,
      missingMoveInDateReason: data.missingMoveInDateReason,
      moveInDate: data.moveInDate ? formattedDate(data.moveInDate) : null,
      signedDocType: data.signedDocType,
      paymentStatus: data.paymentStatus
        ? animalPaymentStatusConverter.fromDb(data.paymentStatus)
        : null,
      isMoveInDatePassed: data.moveInDatePassed,
      applicationStatus: applicationStatusConvertor.fromDb(
        data.applicationStatus,
      ),
      splitStatus: animalStatusDetailsConverter.fromDb(data.statusDetails),
      applicationId: data.applicationId,
      canNotReapplyReason: data.canNotReapplyReason || null,
      petRentDate:
        data.petRentDate && petChargeDateConverter.fromDb(data.petRentDate),
      petFeeDate:
        data.petFeeDate && petChargeDateConverter.fromDb(data.petFeeDate),
    };
  },
};

export const animalRequirementsSetNoteConverter: TFetchConverter<
  TAnimalRequirementsSetNoteDB,
  TAnimalRequirementsSetNoteUI
> = {
  fromDb: data => ({
    description: data.description,
    id: data.id,
    title: data.title,
  }),
};

export const animalRequirementsSetConverter: TFetchConverter<
  TAnimalRequirementsSetDB,
  TAnimalRequirementsSetUI
> = {
  fromDb: data => ({
    default: data.default,
    id: data.id,
    name: data.name,
    notes: (data.notes || []).map(note =>
      animalRequirementsSetNoteConverter.fromDb(note),
    ),
    requirements: data.requirements,
    tenantShouldPayForPet: data.tenantShouldPayForPet,
  }),
};
export const configSetSpiciesRequirementGetConverter: TFetchConverter<
  TSpeciesRequirementUI,
  ESpeciesRequirementDB[]
> = {
  fromDb: data => {
    return {
      dog: data.includes(ESpeciesRequirementDB.DOG),
      cat: data.includes(ESpeciesRequirementDB.CAT),
    };
  },
};

export const mockRequiredDocumentsDB: TRequiredDocumentsUI = {
  [ERequiredDocument.RABIES_VACCINATION]: false,
  [ERequiredDocument.CITY_LICENSE]: false,
  [ERequiredDocument.SPAYED_NEUTERED_DOCUMENT]: false,
  [ERequiredDocument.DOG_BITE_LIABILITY_INSURANCE]: false,
  [ERequiredDocument.PARVO]: false,
};
export const configSetRequiredDocumentsGetConverter: TFetchConverter<
  {
    custom: TCustomRequiredDocumentUI;
    predefined: TRequiredDocumentsUI[];
  },
  TRequiredDocumentsDB[]
> = {
  fromDb: data => {
    const custom: TCustomRequiredDocumentUI[] = [];
    const predefined: TRequiredDocumentsUI = { ...mockRequiredDocumentsDB };

    data.forEach(item => {
      if (item.predefined) {
        predefined[item.name.toUpperCase()] =
          configSetSpiciesRequirementGetConverter.fromDb(
            item.applicableSpecies,
          );
      } else {
        custom.push({
          hasExpirationDate: item.expirable ? 'yes' : 'no',
          id: item.name,
          name: item.name,
          requiredSpecies: configSetSpiciesRequirementGetConverter.fromDb(
            item.applicableSpecies,
          ),
          requiredAnimalTypes: item.applicableAnimalTypes || [],
        });
      }
    });
    return { custom, predefined };
  },
};

export const propertyConfigSetPetRestrictionsGetConverter: TFetchConverter<
  TPropertyConfigSetPetRestrictionsUI,
  TPropertyConfigSetPetRestrictionsDB
> = {
  fromDb: data => {
    return {
      breeds: data.restrictedBreeds,
      species: data.allowedSpecies,

      maxWeightLimit: data.maxPetWeight,
      maxNumberOfPets: data.maxNumOfPetsAllowed,
      isPetAllowed: !data.noPetPolicy ? 'yes' : 'no',
    };
  },
};

export const propertyConfigSetGetConverter: TFetchConverter<
  TPropertyConfigSetGetUI,
  TPropertyConfigSetGetDB
> = {
  fromDb: data => {
    const { custom, predefined } =
      configSetRequiredDocumentsGetConverter.fromDb(
        data.requiredVetRecords || [],
      );
    return {
      id: data.id,
      name: data.name,
      requirements: data.requirements,
      notes: data.notes,
      isDefault: data.isDefault,
      properties: data?.properties || [],
      tenantShouldPayForPet: data.tenantShouldPayForPet,
      petRestrictions: data.petRestrictions
        ? propertyConfigSetPetRestrictionsGetConverter.fromDb(
            data.petRestrictions,
          )
        : { isPetAllowed: 'no' },
      requiredDocuments: predefined,
      customRequiredDocuments: custom,
    };
  },
};
export const residenciesConvertor: TFetchConverter<
  TResidenciesUi,
  TResidencies
> = {
  fromDb: data => {
    return {
      animalResidency: data.animalResidency
        ? animalResidencyConverter.fromDb(data.animalResidency)
        : null,
      tags: data.tags.map(item => tenantTagConverter.fromDb(item)),
      canTagKnown: data.canTagKnown,
      cannotTagKnownReason: data.cannotTagKnownReason,
      id: data.id,
      authorizationStatus: authorizationStatusConverter.fromDb(
        data.authorizationStatus,
      ),
      propertyName: data.propertyName,
      unitNumber: data.unitNumber,
      notes: data.notes.map(note => notesConvertor.fromDb(note)),
      propertyManagementBusinessName: data.propertyManagementBusinessName,
      propertyManagementBusinessLogo: data.propertyManagementBusinessLogo,
      leaseStartDate: data.leaseStartDate
        ? formattedDate(data.leaseStartDate)
        : '-',
      leaseToDate: data.leaseToDate ? formattedDate(data.leaseToDate) : '-',
      policyId: data.policyId,
      status: residenciesStatusConverter.fromDb(data.status),
      isExpired: data.isExpired,
      propertyManagers: data.propertyManagers,
      statusChangeInfo: data.statusChangeInfo
        ? statusInfoWithResourceConverter.fromDb(data.statusChangeInfo)
        : null,
      city: data.city,
      state: data.state && toTitleCase(data.state),
      statusUpdateLocked: data.statusUpdateLocked,
      landlordId: data.landlordId,
      shouldTenantSignAddendum: data.shouldTenantSignAddendum,
      animalRestrictionStatus: data.animalRestrictionStatus,
      animalRestrictionTags: data.animalRestrictionTags,
      otherReason: data.otherRestriction,
      ticketId: data.ticketId,
      animalRequirementsSet:
        data.animalVerificationConfiguration &&
        propertyConfigSetGetConverter.fromDb(
          data.animalVerificationConfiguration,
        ),
    };
  },
};

export const getAnimalConverter: TFetchConverter<
  TAnimalDetailUi,
  TAnimalDetail
> = {
  fromDb: data => {
    return {
      hasObservableDisability: data.hasObservableDisability,
      animal: animalBasicInfoConvertor.fromDb(data.animal),
      tenant: tenantDetailConvertor.fromDb(data.tenant),
      residencies:
        (data.residencies || []).map(item =>
          residenciesConvertor.fromDb(item),
        ) || [],
      applications: (data.applications || []).map(item =>
        animalApplicationConvertor.fromDb(item),
      ),
      vetRecords: (data.vetRecords || []).map(item =>
        animalVetRecordConvertor.fromDb(item),
      ),
      hpDocPackets: (data.hpDocPackets || []).map(packet => ({
        ...getHPDocPacketsConvertor.fromDb(packet),
      })),
      saDocuments: (data.saDocuments || []).map(item =>
        applicationSADocPacketConvertor.fromDb(item),
      ),
      conversions: (data.conversions || []).map(item =>
        animalConversionsConvertor.fromDb(item),
      ),
      residentTypeChanges: (data.residentTypeChanges || []).map(item =>
        residentTypeChangeConvertor.fromDb(item),
      ),
      blockedActions: (data.blockedActions || [])?.map(action =>
        animalBlockedActionConverter.fromDb(action),
      ),
      statusChangeInfo: data.statusChangeInfo
        ? statusChangeInfoConverter.fromDb(data.statusChangeInfo)
        : null,
      missingNameReason: data.missingNameReason,
      missingTypeReason: data.missingTypeReason,
      missingSpeciesReason: data.missingSpeciesReason,
      isToPetConverted: data.isToPetConverted,
      isConversionRemoved: data.isConversionRemoved,
      conversionRemovalReason: data.conversionRemovalReason,
    };
  },
};

export const createAnimalDetailsVetRecordConvertor: TCreateConverter<
  TAnimalDetailVetRecordCreateUi,
  TAnimalDetailVetRecordCreate
> = {
  toDb: data => {
    return {
      animalId: data.animalId,
      records: data.records,
      files: data.files,
      // docName: data.files[0].name,
    };
  },
};

export const animalBreedConvertor: TConvertor<TAnimalBreedUI, TAnimalBreedDB> =
  {
    fromDb: data => {
      return {
        value: data.id || '',
        label: data.value || '',
      };
    },
    toDb: data => {
      return {
        ...(data.label === data.value
          ? { value: data.label }
          : { id: data.value }),
      };
    },
  };

// Animal info Updates START
export const updateAnimalNameConvertor: TCreateConverter<
  TUpdateAnimalNameUI,
  TUpdateAnimalNameDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      name: data.value,
    };
  },
};

export const updateAnimalSpeciesConvertor: TCreateConverter<
  TUpdateAnimalSpeciesUI,
  TUpdateAnimalSpeciesDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      animalSpecies:
        // eslint-disable-next-line no-underscore-dangle
        data.animalSpecies.__isNew__ || !data.animalSpecies.value
          ? { value: data.animalSpecies.label || data.animalSpecies.value }
          : { id: data.animalSpecies.value },
    };
  },
};

export const updateAnimalBreedConvertor: TCreateConverter<
  TUpdateAnimalBreedUI,
  TUpdateAnimalBreedDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      // eslint-disable-next-line no-underscore-dangle
      animalBreed: data.breed.__isNew__
        ? { value: data.breed.value }
        : { id: data.breed.value },
    };
  },
};

export const updateAnimalMicrochipConvertor: TCreateConverter<
  TUpdateAnimalMicrochipDateUI,
  TUpdateAnimalMicrochipDateDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      microchip: data.value,
    };
  },
};

export const updateAnimalTrainedForConvertor: TCreateConverter<
  TUpdateAnimalTrainedForUI,
  TUpdateAnimalTrainedForDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      trainedFor: data.trainedFor,
    };
  },
};

export const updateAnimalGenderConvertor: TCreateConverter<
  TUpdateAnimalGenderUI,
  TUpdateAnimalGenderDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      gender: genderEnumConvertor.toDb(data.value),
    };
  },
};

export const updateAnimalHouseTrainedConvertor: TCreateConverter<
  TUpdateAnimalHouseTrainedUI,
  TUpdateAnimalHouseTrainedDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      houseTrained: data.value === 'Yes',
    };
  },
};

export const updateAnimalBirthDateConvertor: TCreateConverter<
  TUpdateAnimalBirthDateUI,
  TUpdateAnimalBirthDateDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      birthDate: formattedDate(data.value, 'YYYY-MM-DD'),
    };
  },
};

export const updateAnimalWeightConvertor: TCreateConverter<
  TUpdateAnimalWeightUI,
  TUpdateAnimalWeightDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      unit: 'LBS',
      weight: data.value,
    };
  },
};

export const updateAnimalReproductiveConvertor: TCreateConverter<
  TUpdateAnimalReproductiveUI,
  TUpdateAnimalReproductiveDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      reproductive: data.value === 'Yes',
    };
  },
};

export const updateAnimalProfilePictureConvertor: TCreateConverter<
  TUpdateAnimalProfilePictureUI,
  TUpdateAnimalProfilePictureDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      profilePicture: data.profilePicture,
    };
  },
};

export const updateAnimalColorsConvertor: TCreateConverter<
  TUpdateAnimalColorsUI,
  TUpdateAnimalColorsDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      primaryColor: animalColorConvertor.toDb(
        data.primaryColor as TAnimalColorsUI,
      ),
      secondaryColor1: data.secondaryColor1 && data.secondaryColor1.value,
      secondaryColor2: data.secondaryColor2 && data.secondaryColor2.value,
    };
  },
};

export const updateAnimalAggressiveBehaviorConvertor: TCreateConverter<
  TUpdateAnimalAggressiveBehaviorUI,
  TUpdateAnimalAggressiveBehaviorDB
> = {
  toDb: data => {
    return {
      animalId: data.id,
      aggressiveBehavior: data.aggressiveBehavior,
    };
  },
};

// Animal info Updates END

export const aggressiveBehaviorConverter: TFetchConverter<
  TAggressiveBehaviorUI,
  TAggressiveBehaviorDB
> = {
  fromDb: data => {
    return {
      acted: data.acted ? 'Yes' : 'No',
      incidentDetails: data.incidentDetails,
    };
  },
};

export const animalInfoPropConverter: TFetchConverter<
  TAnimalInfoPropUI,
  TAnimalInfoPropDB
> = {
  fromDb: data => ({
    value: data.value,
    predefined: data.predefined,
    predefinedId: data.predefinedId,
  }),
};

export const animalColorConvertor: TConvertor<
  TAnimalColorsUI,
  TAnimalColorsDB
> = {
  fromDb: data => {
    return {
      value: data.id || '',
      label: data.value || '',
      __isNew__: !!data.id,
    };
  },
  toDb: data => {
    return {
      // eslint-disable-next-line no-underscore-dangle
      id: !data.__isNew__ ? data.value : null,
      value: data.label,
    };
  },
};

// Animal Application Actions START

export const residencyDetailConverter: TFetchConverter<
  TApproveApplicationFormProps,
  TApproveApplicationFormPropsUI
> = {
  fromDb: data => ({
    propertyId: data.property.value,
    unitNumber: data.unit.label,
    moveInDate: data.moveInDate,
    leaseToDate: data.leaseToDate,
  }),
};

export const approveApplicationConverter: TCreateConverter<
  TApproveApplicationUI,
  TApproveApplicationDB
> = {
  toDb: data => {
    return {
      tenantResidencyId: data.tenantResidencyId,
      animalId: data.animalId,
      ...(data.residenceId && { residenceId: data.residenceId }),
      ...(data.residencyDetails && {
        residencyDetails: residencyDetailConverter.fromDb(
          data.residencyDetails,
        ),
      }),
      ...(data.conditionalApproveDetails && {
        conditionalApproveDetails: {
          dueDate: data.conditionalApproveDetails.dueToDate,
          reason: data.conditionalApproveDetails.reason,
        },
      }),
    };
  },
};

const moveOutOrRetractReasonTypeUItoDB: Record<
  EMoveOutOrRetractReasonTypeUI,
  EMoveOutOrRetractReasonTypeDB
> = {
  [EMoveOutOrRetractReasonTypeUI.ANIMAL_HAS_PASSED_AWAY]:
    EMoveOutOrRetractReasonTypeDB.ANIMAL_HAS_PASSED_AWAY,
  [EMoveOutOrRetractReasonTypeUI.ANIMAL_HAS_RE_HOMED]:
    EMoveOutOrRetractReasonTypeDB.ANIMAL_HAS_RE_HOMED,
};

export const deleteAnimalConverter: TCreateConverter<
  TDeleteAnimalUI,
  TDeleteAnimalDB
> = {
  toDb: data => {
    let moveOutReason;
    if (data.otherReason) {
      moveOutReason = { other: data.otherReason };
    } else if (data.moveOutReason) {
      moveOutReason = {
        predefined: moveOutOrRetractReasonTypeUItoDB[data.moveOutReason],
      };
    }
    return {
      animalId: data.animalId,
      ...(moveOutReason && { moveOutReason }),
      ...(data.retractionReason && { retractionReason: data.retractionReason }),
    };
  },
};
